import React, { useCallback, useEffect, useState } from 'react';
import { View, ActivityIndicator } from 'react-native';
import { router } from 'expo-router';
import * as FileSystem from 'expo-file-system';
import { InterJSON, storedMagazine } from '@/services/Datatypes';
import { readLocalJsonFile } from '@/services/readLocalJsonFile';
//import { fetchSingle, fetchImages } from '@/services/FetchFromAPI';
import { checkIfInterstitial } from '@/services/checkIfInterstitial';
import ViewerComponent from '@/components/PDF/ViewerComponent.web';
import PageNavigation from '@/components/PDF/PageNavigation.web';
import ArticleModal from '@/components/ArticleModal.web';
import { useFocusEffect, useRouter } from 'expo-router';
//import { calculateDirectorySize } from '@/services/calculateDirectorySize';
import { useBoundStore, usePersistBoundStore, usePersistSecureBoundStore } from '@/services/zustand/Store';
import { fetchSubscriptions } from '@/services/fetchSubscriptions';
import { isLoggedIn } from '@/services/typo3api/auth.web';

export const calculateDirectorySize = async (dir: string) => {
  return new Promise(async (resolve, reject) => {

    const response: any = await fetch(
      '/web-server-api/calculateDirectorySize',
      {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
          },
          body: JSON.stringify({
              "dir": dir
          }),
      }
    );

    const data = await response.json();

    resolve(data.directorySize);

  });
};

export const fetchSingle = async (date: string, edition: string) => {
  return new Promise(async (resolve, reject) => {

    const response = await fetch(
      '/web-server-api/fetchFromAPI',
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          "date": date,
          "edition": edition,
          "type": "single"
        }),
      }
    );

    const data = await response.json();

    resolve(data.response);

  });
};

export const fetchImages = async (date: string, edition: string) => {
  return new Promise(async (resolve, reject) => {


    const response = await fetch(
      '/web-server-api/fetchFromAPI',
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          "date": date,
          "edition": edition,
          "type": "images"
        }),
      }
    );

    const data = await response.json();

    resolve(data.response);


  });
};

export const getInterstitialJson = async (date: any, edition: any) => {

  return new Promise(async (resolve, reject) => {
      
      const interstitialJsonData: any = await fetch(
          '/web-server-api/getJson',
          {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              },
              body: JSON.stringify({
                  "type": 'interstitialJson',
                  "date": date,
                  "edition": edition
              }),
          }
      );

      const data = await interstitialJsonData.json();
      
      if(data) {
          resolve(data.jsonData);
      }
      else {
          reject('no_data');
      }

  });

};

export default function Viewer() {
  const magazineDataForViewer = useBoundStore.getState().magazineDataForViewer;
  const currentMagazine = useBoundStore.getState().magazine;
  const currentPage = useBoundStore(useCallback((state) => state.currentPage, []));
  const [visiblePage, setVisiblePage] = useState(1);
  const updateCurrentPage = useBoundStore(useCallback((state) => state.updateCurrentPage, []));
  const [viewerPagesData, setViewerPagesData] = useState<{ pageNumber: number; }[]>([]);
  //const flatListRef = useRef<FlatList>(null);
  //const pageWidth = Dimensions.get('window').width;
  const user = usePersistSecureBoundStore.getState().user;
  const updateSubscriptions = usePersistSecureBoundStore.getState().updateSubscriptions;
  const [loading, setLoading] = useState(true);

  const archiveSizesCalculation = async () => {

    if (currentMagazine) {
      const storedMagazine = getStoredMagazineByMagazine(currentMagazine);
      if (storedMagazine) {
        //const size = await calculateDirectorySize(`${FileSystem.documentDirectory}/epaper/${storedMagazine.magazine.date}/${storedMagazine.magazine.edition}/`);
        //const imgSize = await calculateDirectorySize(`${FileSystem.documentDirectory}/epaper/${storedMagazine.magazine.date}/img/`);

        const size = await calculateDirectorySize(`./epaper/${storedMagazine.magazine.date}/${storedMagazine.magazine.edition}/`);
        const imgSize = await calculateDirectorySize(`./epaper/${storedMagazine.magazine.date}/img/`);

        updateStoredMagazine({
          magazine: storedMagazine.magazine,
          epaperDownloaded: storedMagazine.epaperDownloaded,
          imgDownloaded: storedMagazine.imgDownloaded,
          paperFilesize: size as number,
          imgFilesize: imgSize as number,
        });
      }
    }
  }

  const preparingStoredData = async () => {
    if (currentMagazine) {
      const storedMagazine = getStoredMagazineByMagazine(currentMagazine);

      if (storedMagazine == null) {
        const newStoredMagazine: storedMagazine = {
          magazine: currentMagazine,
          epaperDownloaded: false,
          imgDownloaded: false,
          paperFilesize: 0,
          imgFilesize: 0,
        }
        updateStoredMagazine(newStoredMagazine)
      }
    }
  }

  const checkIfMagazineExists = async () => {
    return new Promise(async (resolve, reject) => {

      if (currentMagazine) {
        const magazineExists: any = await fetch(
          '/web-server-api/checkIfMagazineExists',
          {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              },
              body: JSON.stringify({
                  "date": currentMagazine.date,
                  "edition": currentMagazine.edition
              }),
          }
        );
    
        const data = await magazineExists.json();
        
        if(data) {
            resolve(data.response);
        }
        else {
            reject(false);
        }
      }
      else {
        reject(false);
      }
    });
  };

  const preparingPDF = async () => {
    
    if (currentMagazine) {
      
      const storedMagazine = getStoredMagazineByMagazine(currentMagazine);
      if (storedMagazine && !storedMagazine.epaperDownloaded) {
        const succeSingle = await fetchSingle(currentMagazine.date, currentMagazine.edition);
        if (succeSingle === false) {
          updateStoredMagazine({
            magazine: storedMagazine.magazine,
            epaperDownloaded: false,
            imgDownloaded: storedMagazine.imgDownloaded,
            paperFilesize: storedMagazine.paperFilesize,
            imgFilesize: storedMagazine.imgFilesize,
          });
          router.navigate(`../PDFSelector`); 
          return;
        } else {
          setLoading(false);
          updateStoredMagazine({
            magazine: storedMagazine.magazine,
            epaperDownloaded: new Date(),
            imgDownloaded: storedMagazine.imgDownloaded,
            paperFilesize: storedMagazine.paperFilesize,
            imgFilesize: storedMagazine.imgFilesize,
          });
        }
      }
    }
  }

  const preparingIMG = async () => {
    if (currentMagazine) {
      const storedMagazine = getStoredMagazineByMagazine(currentMagazine);
      if (storedMagazine && !storedMagazine.imgDownloaded) {
        const succeImages = await fetchImages(currentMagazine.date, currentMagazine.edition);
        if (succeImages === false) {
          updateStoredMagazine({
            magazine: storedMagazine.magazine,
            epaperDownloaded: storedMagazine.epaperDownloaded,
            imgDownloaded: false,
            paperFilesize: storedMagazine.paperFilesize,
            imgFilesize: storedMagazine.imgFilesize,
          });
          return
        } else {
          updateStoredMagazine({
            magazine: storedMagazine.magazine,
            epaperDownloaded: storedMagazine.epaperDownloaded,
            imgDownloaded: new Date(),
            paperFilesize: storedMagazine.paperFilesize,
            imgFilesize: storedMagazine.imgFilesize,
          });
        }
      }
    }
  }

  async function findInterstitial() {
    if (currentMagazine) {

      const interstitialJson: any = await getInterstitialJson(currentMagazine.date, currentMagazine.edition);

      if(interstitialJson) {
        updateInterstitialData(interstitialJson);
      } else {
        updateInterstitialData(null);
      }
    }
  }

  async function runStateMachine() {    
    switch (viewerState) {      
      case 'checkPermissions':
        setLoading(true);
        if (await isLoggedIn()) {
          if (true) {
            const newSubscriptions = await fetchSubscriptions('27');
            updateSubscriptions(newSubscriptions);
          }
          if (true) {
            
          } else {
            setViewerState('redirectSubscribe');
          }
        } else {
          setViewerState('redirectLogin');
        }
        break;
        
      case 'preparingStoredMagazine':
        setLoading(true);
        await preparingStoredData();

        const magazineExists = await checkIfMagazineExists();
        if(magazineExists) {
          await findInterstitial();
          setViewerState('completed');
        }
        else {
          setViewerState('downloadPDF');
        }
        
        break;

      case 'downloadPDF':
        setLoading(true);
        await preparingPDF();
        setViewerState('findInterstitial');
        break;

      case 'findInterstitial':
        setLoading(true);
        await findInterstitial();          
        setViewerState('downloadIMG');
        break;

      case 'downloadIMG':
        setLoading(true);
        await preparingIMG();
        //setLoading(false);      
        setViewerState('completed');
        break;

      case 'redirectLogin':
        router.navigate('/Login');
        break;

      case 'redirectSubscribe':
        router.navigate('/Subscribe');
        break;

      case 'completed':
        setLoading(false);
        await archiveSizesCalculation();
        break;

      default:
        console.error("Unexpected state:", viewerState);
        break;
    }
  }

  useEffect(() => {
    setLoading(true);
    
    const onUpdateCurrentMagazine = async () => {

      if (user) {

        const newSubscriptions = await fetchSubscriptions(user.id);
        updateSubscriptions(newSubscriptions);
      } else {
        updateSubscriptions([]);
        router.navigate('/Login');
        return;
      }
      if (currentMagazine && currentMagazine.numberOfPages) {
        const viewerPagesData = Array.from({ length: currentMagazine.numberOfPages }, (_, index) => ({
          pageNumber: index + 1,
        }));
        setViewerPagesData(viewerPagesData);
        //pageDownloader(currentMagazine, currentPage);
        setLoading(false);
        //scrollToIndex(0);        
      }
    }

    onUpdateCurrentMagazine();
  }, [currentMagazine]);


  return (
    <>
      {loading ? (<ActivityIndicator size="large" color="#0000ff" />) : (
        <View style={{
          flex: 1,
          justifyContent: 'flex-start',
          alignItems: 'center',
          width: '100%',
        }}>

          {!loading && <ViewerComponent magazineDataForViewer={magazineDataForViewer} />}
          {!loading && <PageNavigation magazineDataForViewer={magazineDataForViewer} />}
          {!loading && <ArticleModal />} 
        </View>
      )}
    </>
  );
}